// extracted by mini-css-extract-plugin
module.exports = {"divider":"Account_divider__Sa7gC","name":"Account_name__1UBge"};